// ShimmerIcon.tsx
import React from 'react';
import {Animated} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

type ShimmerIconProps = {
  size: number;
  colors: string[];
  children: React.ReactNode;
};

export function ShimmerIcon({size, colors, children}: ShimmerIconProps) {
  return (
    <Animated.View
      style={{
        width: size,
        height: size,

      }}>
      <LinearGradient
        // Você pode ajustar start/end para mudar o ângulo inicial do gradiente
        start={{x: 0, y: 0}}
        end={{x: 1, y: 1}}
        colors={colors}
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          borderWidth: 1,
          borderColor: '#f5c345',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        {children}
      </LinearGradient>
    </Animated.View>
  );
}
